export type WelcomeStep = {
  eyebrow: string;
  title: string;
  body: string;
  cta: string;
};

export const welcomeSteps: WelcomeStep[] = [
  {
    eyebrow: 'Welcome to Corvus',
    title: 'Listen to your customers.',
    body: 'Corvus runs AI-moderated voice and video interviews so your team can hear from hundreds of customers in the time it used to take to schedule one.',
    cta: 'Continue'
  },
  {
    eyebrow: 'Design',
    title: 'Build interviews in minutes.',
    body: 'Start from a goal, let the agent draft your topics, then refine the questions, archetype, and tone to match the conversations you want to have.',
    cta: 'Continue'
  },
  {
    eyebrow: 'Analyze',
    title: 'Close the empathy gap.',
    body: 'Codes, themes, and quant graphs surface the patterns across every transcript — so hundreds of conversations become decisions you can ship.',
    cta: 'Get started'
  }
];
